import React from "react";
import './Home.css'
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from 'react-bootstrap';
import eng1 from '../Images/eng/ff.png';
import eng2 from '../Images/eng/fg.png';
import HomeCarousel from "../Components/HomeCarousel";
import Posts from "../Components/Posts";

import HomeLivingCarousel from "../Components/HomeLivingCarousel";
import SU from '../Images/outreach/cc.png';
import SA from '../Images/outreach/gg.png';

export default function Home () {
  return (
    <>
        <div className="homeHero">
            <Container className="homeHeroContainer">
                <h1 className="aladin white">Yvie|DODEQ</h1>
                <p className="baka">LIVE. WORK. INSPIRE</p>
            </Container>
        </div>
        <div className="homeAbout">
            <Container className="homeAboutContainer">
                <h1>Meet Yvie</h1>
                <p className="altMont">Hi! My name is Yvonne Amaria and my purpose is to inspire and build communities, promoting cultural preservation and expression in every form. Join me on my little adventures as we navigate the world and challenge ourselves to live, work towards a purpose, and inspire with said purpose. Welcome and have fun on this side of the sphere!</p>
            </Container>
        </div>
        <div className="homeEvents">
            <h1 className="pb-5">YVIE STYLE IT</h1>
            <HomeCarousel />
        </div>
        <div className="homeEvents">
            <h1>YVIE WRITE IT</h1>
            <Posts />
            <a href="/yvie-write-it"><h4 className="mont">View More...</h4></a>
        </div>
        <div className="homeEng">
          <h1 className="pb-5">YVIE'S AN ENGINEER</h1>
          <div className="grid-container">
            <img src={eng1} alt="Yvie Engineer" className="resume-photo"/>
            <img src={eng2} alt="Yvie Engineer" className="resume-photo"/>
          </div>
        </div>
        {/* <div className="homeEvents">
            <Eng />
        </div> */}
        <section className="ngoSection">
          <div className="ngoDetails">
            <h2>SheUnitesAfrica</h2>
            <p className="ngoSubtitle">
              Empowering girls and women across Africa through education, mentorship, health awareness, and economic opportunities.
            </p>
          </div>
          <div className="aboutSection">
            <div className="aboutContent">
              <h3>
              Violet Care Foundation for Women and Nature, Powered by SheUnitesAfrica
              </h3>
              <p>
                Originally founded as SheUnitesAfrica (SUA) in 2020 by Miss Anastacia Amarachi Nickson and Miss Chidimma Frances Okoye, our organization was established with a deep commitment to inspiring and empowering females to contribute to societal transformation and positive change. Our mission remains unwavering: to create a world where women and girls have equal opportunities to thrive.
              </p>
              <p>Through careful research and engagement with vulnerable communities, we recognize that women and girls experience the scourge of poverty in ways that limit their education, financial security, and overall well-being. Our initiatives are designed to bridge this gap, ensuring that females can access the same opportunities as men and boys.</p>
              <div className="btnPair">
                <button className="primaryBtn">Learn More</button>
                <button className="primaryBtn">Donate Now</button>
              </div>
            </div>
            <div className="aboutImages">
              <img src={SU} alt="SheUnitesAfrica program" />
              <img src={SA} alt="Mentorship session" />
            </div>
          </div>
        </section>
        <div className="homeEvents">
            <h1>YVIE EVENTS</h1>

            <h6 className="Mont">No Upcoming Events...</h6>
            {/* <div id="event" className="event-item fade-in-up p-5">
                <div className="event-date">
                    <div className="month">JUN</div>
                    <div className="day">23</div>
                </div>
                <div className="event-details">
                    <img src={SU} alt="Title of the Risen Event" />
                    <div>
                    <h3>Title of the Risen Event</h3>
                    <p>1015 California Ave, Los Angeles CA<br />7:00 pm — 8:00 pm</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    <a href={`/events/risen-event`}>View Event Details →</a>
                    </div>
                </div> 
            </div> */}
        </div>
        <HomeLivingCarousel />
    </>
  );
};